import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent,
  useIonAlert,
} from '@ionic/react';
import {useContext} from 'react';
import {useHistory} from 'react-router';

import './SensorCard.css';
import autoFetcher from '../services/Autofetcher';
import {AppContext, getAuthToken, getEnvironment} from '../State';
import {sitecontrollerGlobals} from '../variables';

const SensorCard: React.FC<{sensor: any, site: any}> = (props: any) => {
  const {state} = useContext(AppContext);
  const history = useHistory();

  const {sensor, site} = props;

  const authToken = getAuthToken(state);
  const environment = getEnvironment(state);
  const environmentOptions = (sitecontrollerGlobals.environments as any)[environment];

  const [present] = useIonAlert();

  const executePayloadAction = (action: any) => {
    const isNoMoaAction = ['NBUTTON', 'NMC'].includes(sensor.type);
    let message: string|undefined = 'Are you sure?';

    if (isNoMoaAction && action.key === 'confirm') {
      message = 'Alles is in orde?';
    } else if (isNoMoaAction && action.key === 'set_present') {
      message = undefined;
    } else if (isNoMoaAction && action.key === 'set_absent') {
      message = 'U vertrekt binnen 5min';
    }

    const executor = () => {
      fetch(`${environmentOptions.url}/api/action/${sensor.id}/${action.key}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
      }).then(() => autoFetcher.fetch());
    };

    present({
      header: action.key === 'set_present' ? 'Weer aanwezig?' : action.label,
      message,
      buttons: [
        {text: 'Cancel'},
        {text: isNoMoaAction ? 'OK' : 'Execute', handler: () => executor()},
      ],
    });
  };

  const renderInfoBadge = () => {
    if (sensor.badge) {
      return <IonBadge color="light">{sensor.badge.text}</IonBadge>
    }

    return null;
  };

  return (
    <div className="sensor-card-container">
      <IonCard onClick={() => history.push(`/site/${site.id}/sensor/${sensor.id}`)}>
        <IonCardContent>
          <div className="sensor-card-title">
            <img src={`${environmentOptions.url}/build/icons/${sensor.icon}`} style={{height: '2em'}} alt="Sensor status"/>
            <div className="sensor-card-title-badges">
              {renderInfoBadge()}
              <IonBadge color={sensor.statusColor[0]}>{sensor.statusAbbr}</IonBadge>
            </div>
          </div>
          <div className="sensor-card-ding-row">
            <div className="sensor-card-details">
              <div><strong>{sensor.name}</strong></div>
              <div><em>{sensor.category}</em></div>
              {sensor.description ? <div><small>{sensor.description}</small></div> : null}
            </div>
            {sensor.payloadActions.length > 0 ? (
              <div className="sensor-card-button-container">
                {sensor.payloadActions.map((action: any, index: string) => (
                  <IonButton
                    key={index}
                    size="small"
                    color="light"
                    disabled={action.disabled}
                    onClick={event => {
                      event.stopPropagation();
                      executePayloadAction(action);
                    }}
                  >
                    {action.label}
                  </IonButton>
                ))}
              </div>
            ) : null}
          </div>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default SensorCard;
